import { Inject, Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { Location } from '@angular/common';
import { DOCUMENT } from '@angular/common';
import { CMS_END_POINTS } from '../const/api';
import { ConfigService } from './config.service';
import { SharedService } from './shared.service';

@Injectable({
  providedIn: 'root'
})
export class MetaTagsService {
  defalutData: any = {
    title: "Qjet | The official Web site of the Qjet",
    description: "The official Web site of the Qjet",
    keywords: ["Qjet", "Qjet", "Qjet"]
  };
  private renderer: Renderer2;

  constructor(
    private metaService: Meta,
    private titleService: Title,
    private rendererFactory: RendererFactory2,
    private location: Location,
    @Inject(DOCUMENT) private document: Document,
    private configService: ConfigService,
    private SharedService: SharedService
  ) {
    this.renderer = this.rendererFactory.createRenderer(null, null);
  }

  updateMetaTags(metaData: any = null) {
    const baseURL: string = this.SharedService.getDomainURL();
    const fullPath = this.location.path() || "";
    const fullURL: string = `${baseURL}${fullPath}`;
    // 
    this.updateTitle(metaData?.title || this.defalutData.title);
    this.updateDescription(metaData?.description || this.defalutData.description);
    this.updateKeywords(metaData?.keywords || this.defalutData.keywords);
    this.createLink('canonical', fullURL);
    this.createLink('alternate', fullURL);
    this.updateImage(metaData?.img, metaData?.title || this.defalutData.title);
    this.updateMainLink(fullURL);
    this.createLink('copyright', fullURL);
    const linkElement = this.renderer.createElement('link');
    this.renderer.setAttribute(linkElement, 'rel', 'image_src');
    this.renderer.setAttribute(linkElement, 'href', metaData?.img);
    this.renderer.appendChild(this.document.head, linkElement);
    // this.createLink('image_src', metaData?.img);
  }

  updateMainLink(link: any): void {
    const lang = link.split('/')?.[3];
    
    this.metaService.updateTag({ name: 'og:url', content: link });
    this.metaService.updateTag({ name: 'twitter:url', content: link });

    this.metaService.updateTag({ name: 'twitter:site', content: 'QatarFuel_Woqod' });
    this.metaService.updateTag({ name: 'twitter:creator', content: 'QatarFuel_Woqod' });


    this.metaService.updateTag({ httpEquiv: 'content-language', content: lang });
    this.metaService.updateTag({ name: 'robots', content: 'index, follow' });
    this.metaService.updateTag({ name: 'shortlink', content: link });

    this.metaService.updateTag({ name: 'original-source', content: link });
    this.metaService.updateTag({ name: 'referrer', content: 'origin-when-cross-origin' });
    this.metaService.updateTag({ name: 'rights', content: link });


    this.metaService.updateTag({ name: 'dcterms.title', content: link });
    this.metaService.updateTag({ name: 'dcterms.creator', content: 'qjet' });
    this.metaService.updateTag({ name: 'dcterms.description', content: link });
    this.metaService.updateTag({ name: 'dcterms.publisher', content: 'qjet' });
    this.metaService.updateTag({ name: 'dcterms.contributor', content: link });
    this.metaService.updateTag({ name: 'dcterms.identifier', content: link });
    this.metaService.updateTag({ name: 'dcterms.source', content: link });
    this.metaService.updateTag({ name: 'dcterms.language', content: lang });
    this.metaService.updateTag({ name: 'dcterms.rights', content: link });

    this.metaService.updateTag({ property: 'fb:pages', content: '' });
    this.metaService.updateTag({ property: 'fb:app_id', content: '' });


    this.metaService.updateTag({ property: 'og:site_name', content: 'qjet' });
    this.metaService.updateTag({ property: 'og:type', content: 'article' });

    this.metaService.updateTag({ property: 'og:locale', content: `${lang}_${(lang || '').toUpperCase()}` });

    this.metaService.updateTag({ httpEquiv: 'content-script-type', content: 'text/javascript' });
    this.metaService.updateTag({ httpEquiv: 'x-ua-compatible', content: 'ie=edge' });    
    this.metaService.updateTag({ name: 'author', content: 'qjet' });   

  }

  updateKeywords(keywords: any): void {
    this.metaService.updateTag({ name: 'keywords', content: keywords.toString() });
  }

  updateTitle(title: string): void {
    this.titleService.setTitle(title);
    this.metaService.updateTag({ name: 'title', content: title });
    this.metaService.updateTag({ property: 'og:title', content: title });
    this.metaService.updateTag({ name: 'twitter:title', content: title });

  }

  updateDescription(description: string): void {
    this.metaService.updateTag({ name: 'description', content: description });
    this.metaService.updateTag({ name: 'description', content: description });
    this.metaService.updateTag({ property: 'og:description', content: description });
    this.metaService.updateTag({ name: 'twitter:description', content: description });
  }

  updateImage(img: string, title: string): void {
    const defaultImage = this.SharedService.getDomainURL() + "/assets/images/logo-social.jpg";
    const image = img ? this.imageSourcePipe(img) : defaultImage;
    // 
    this.metaService.updateTag({ name: 'og:image', content: image });
    this.metaService.updateTag({ name: 'twitter:image:alt', content: title });
    this.metaService.updateTag({ name: 'og:image:url', content: image });
    this.metaService.updateTag({ name: 'og:image:alt', content: title });

    this.metaService.updateTag({ name: 'twitter:image:width', content: '1600' });
    this.metaService.updateTag({ name: 'twitter:image:height', content: '900' });

    this.metaService.updateTag({ name: 'og:image:width', content: '1200' });
    this.metaService.updateTag({ name: 'og:image:height', content: '630' });



  }

  imageSourcePipe(imageFile: string = ''): string {
    if (!imageFile) return '';
    // Check if the route is an external URL
    if (
      imageFile.startsWith('//') ||
      imageFile.startsWith('http://') ||
      imageFile.startsWith('https://') ||
      imageFile.startsWith('www.')
    ) {
      return imageFile;
    } else if (imageFile === 'loadingImage') {
      return 'assets/images/default-img.gif'
    } else if (imageFile === 'errorImage') {
      return 'assets/images/default-qjet.jpg'
    } else {
      return imageFile ? this.configService.baseURL + CMS_END_POINTS.GET_IMAGE_BY_FILE + "?id=" + imageFile : 'assets/images/default-img.webp';
    }
  }

  createLink(rel: string, url: string): void {
    if (typeof window !== 'undefined') {
      const existingLink = this.document.head.querySelector(`link[rel="${rel}"]`);
      if (existingLink) {
        this.renderer.setAttribute(existingLink, 'href', url);
      } else {
        const linkElement = this.renderer.createElement('link');
        this.renderer.setAttribute(linkElement, 'rel', rel);
        this.renderer.setAttribute(linkElement, 'href', url);
        this.renderer.appendChild(this.document.head, linkElement);
      }
    }
  }

  getPageMetaTags(){
    if (typeof window !== 'undefined') {
      let url = window.location.href;
      return {
        title: document.title || '',
        description: document.querySelector('meta[name="description"]')?.getAttribute('content') || '',
        img: document.querySelector('meta[name="og:image"]')?.getAttribute('content') || '',
        url: url
      };
    }
    return null;
  }

}
